import { render, staticRenderFns } from "./btmCov.vue?vue&type=template&id=32a13eda&scoped=true"
import script from "./btmCov.vue?vue&type=script&lang=js"
export * from "./btmCov.vue?vue&type=script&lang=js"
import style0 from "./btmCov.vue?vue&type=style&index=0&id=32a13eda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a13eda",
  null
  
)

export default component.exports